import React from 'react';
import ReactDOM from 'react-dom';
import styles from './UnsavedChangesWarning.module.scss';

interface UnsavedChangesWarningProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const UnsavedChangesWarning: React.FC<UnsavedChangesWarningProps> = ({
  isOpen,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className={styles.modalOverlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="unsaved-changes-title"
      data-testid="unsaved-changes-modal-overlay"
    >
      <div
        className={styles.popupContainer}
        data-testid="unsaved-changes-popup-container"
      >
        <div
          className={styles.contentSection}
          data-testid="unsaved-changes-content"
        >
          <h2
            id="unsaved-changes-title"
            className={styles.title}
            data-testid="unsaved-changes-title"
          >
            Unsaved Changes
          </h2>
          <p className={styles.message} data-testid="unsaved-changes-message">
            You have unsaved edits that will be lost. Are you sure you want to
            close?
          </p>
        </div>

        <div className={styles.buttonRow} data-testid="unsaved-changes-buttons">
          <button
            onClick={onCancel}
            className={styles.buttonSecondary}
            data-testid="unsaved-changes-cancel-button"
          >
            No, Keep Editing
          </button>
          <button
            onClick={onConfirm}
            className={styles.buttonDanger}
            data-testid="unsaved-changes-confirm-button"
          >
            Yes, Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UnsavedChangesWarning;
